module.exports = __webpack_public_path__ + "img/cb0355f.jpg";